import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MainContainer } from './styles.style'
import Banner from '../../../assets/images/muvibus/banner.png'
import BannerMobile from '../../../assets/images/muvibus/banner-mobile.png'
import MuvibusHistorySection from './components/history/history.page'
import MuvibusRegisterSection from './components/register/register.page'
import MuvibusAdvantagesSection from './components/advantages/advantages.page'
import MuvibusDestinationsSection from './components/destinations/destinations.page'
import { TripSearchSection } from '../launch/components/trip-search-section'

class MuvibusPage extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<MainContainer>
				<div className="banner-container">
					<div className="banner">
						<img src={Banner} alt="Muvibus" />
					</div>
					<div className="banner-mobile">
						<img
							className="img-responsive"
							src={BannerMobile}
							alt="Muvibus"
						/>
					</div>
				</div>
				<TripSearchSection
					muvibus={true}
					className="trip-search-section-muvibus"
				/>
				<MuvibusDestinationsSection />
				<MuvibusAdvantagesSection />
				<MuvibusHistorySection />
				<MuvibusRegisterSection />
			</MainContainer>
		)
	}
}

const mapStateToProps = (store) => ({
	user: store.user,
})

const connectedMuvibusPage = withRouter(
	connect(mapStateToProps, null)(MuvibusPage)
)
export { connectedMuvibusPage as ModuleRootComponent }
